import React, { useRef, useEffect } from 'react';
import PhraseList from './PhraseList';

const LessonDetail = ({
  lesson,
  onBack,
  onAddPhrase,
  onDeletePhrase,
  onShowEnlarged,
  newPhrase,
  setNewPhrase,
  paginatedPhrases,
  currentPage,
  phrasesPerPage,
  paginate,
  splitPhrase,
  // Add phrase recording props
  isAddPhraseRecording,
  addPhraseAudioURL,
  startAddPhraseRecording,
  stopAddPhraseRecording,
  transcribeAddPhraseAudio,
  isAddPhraseTranscribing,
  addPhraseRecordingTime,
}) => {
  const phraseInputRef = useRef(null);

  // Giữ focus cho input khi component re-render
  useEffect(() => {
    if (phraseInputRef.current && document.activeElement !== phraseInputRef.current) {
      phraseInputRef.current.focus();
    }
  }, [newPhrase]);

  if (!lesson) return null;

  return (
    <div className="bg-opacity-50 backdrop-filter backdrop-blur-lg p-8 rounded-3xl shadow-2xl">
      <button
        onClick={onBack}
        className="mb-6 px-6 py-4 rounded-xl transition-all transform hover:scale-105 bg-red-600 hover:bg-red-700 text-white shadow-lg hover:shadow-xl"
      >
        <div className="flex items-center space-x-4">
          <span className="text-3xl">←</span>
          <h2 className="text-3xl lg:text-4xl font-bold">
            {lesson.title}
          </h2>
        </div>
      </button>

      <div className="flex items-center mb-8">
        <div className="relative flex-grow">
          <input
            ref={phraseInputRef}
            type="text"
            value={newPhrase}
            onChange={(e) => setNewPhrase(e.target.value)}
            placeholder="Nhập cụm từ mới (VD: Hello - Xin chào)"
            className={`w-full text-lg p-4 pr-16 rounded-l-xl border-2 border-r-0 bg-white border-gray-300 text-gray-800 placeholder-gray-500 focus:border-red-500 focus:ring-red-500 focus:outline-none transition-colors`}
          />
          <button
            onClick={isAddPhraseRecording ? stopAddPhraseRecording : startAddPhraseRecording}
            className={`absolute right-2 top-1/2 transform -translate-y-1/2 w-10 h-10 rounded-full flex items-center justify-center transition-all ${
              isAddPhraseRecording
                ? 'bg-red-500 hover:bg-red-600 text-white animate-pulse'
                : 'bg-red-600 hover:bg-red-700 text-white'
            }`}
            title={isAddPhraseRecording ? 'Bấm để dừng ghi âm' : 'Ghi âm cụm từ (tự động chuyển thành text)'}
          >
            🎤
          </button>
        </div>
        <button
          onClick={onAddPhrase}
          className={`text-lg font-semibold px-8 py-4 rounded-r-xl bg-red-600 hover:bg-red-700 text-white transition-colors`}
        >
          +
        </button>

        {/* Hiển thị trạng thái transcribing */}
        {isAddPhraseTranscribing && (
          <div className={`ml-2 px-4 py-4 rounded-xl bg-red-600 text-white`}>
            ⏳ Đang xử lý...
          </div>
        )}
      </div>

      <PhraseList
        phrases={lesson.phrases || []}
        paginatedPhrases={paginatedPhrases}
        onDeletePhrase={onDeletePhrase}
        onShowEnlarged={onShowEnlarged}
        splitPhrase={splitPhrase}
        currentPage={currentPage}
        phrasesPerPage={phrasesPerPage}
        paginate={paginate}
      />
    </div>
  );
};

export default LessonDetail;
